import { Box, FormControl, InputLabel, Stack, TextField } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';

import type { OrganizationEditDialogForm } from './OrganizationEditDialog.types';

export const OrganizationEditDialogContentEdit = () => {
  const {
    control,
    register,
    formState: { errors }
  } = useFormContext<OrganizationEditDialogForm>();
  const id = useWatch({ control, name: 'id' });

  return (
    <Stack sx={{ marginTop: '1rem' }} spacing={2}>
      <Box>
        <InputLabel id="organizationName">Organization Name</InputLabel>
        <FormControl fullWidth>
          <TextField
            {...register('name', { required: true })}
            error={!!errors.name}
            variant="outlined"
          />
        </FormControl>
      </Box>
      <Box>
        <InputLabel id="organizationCode">Organization Code</InputLabel>
        <FormControl fullWidth>
          <TextField
            {...register('label', { required: true })}
            error={!!errors.label}
            variant="outlined"
            disabled={id !== -1}
          />
        </FormControl>
      </Box>
    </Stack>
  );
};

export default OrganizationEditDialogContentEdit;
